import { useMemo } from "react"

export const useIntials = (user?: { displayName: string }): string | undefined => {

    const initials = useMemo(() => user?.displayName.split(' ').map(word => word.charAt(0)).join('').toUpperCase(), [user])

    return initials

}